import { BRAND } from "@/brand.config";

export const Wordmark = ({ size = "text-xl", showStatus = true, suffix }) => (
  <div className="flex items-center gap-3" data-testid="wordmark">
    <span className={`wordmark whitespace-nowrap ${size}`}>
      {BRAND.wordmark}
      <span className="dot" aria-hidden="true" />
    </span>
    {suffix && <span className="eyebrow" style={{ color: "var(--blue)" }}>{suffix}</span>}
    {showStatus && (
      <span className="eyebrow border border-[var(--line)] rounded px-1.5 py-0.5" data-testid="early-access-label">
        {BRAND.statusLabel}
      </span>
    )}
  </div>
);
